import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import {
  TRUST_DIRECTORY_ENTRIES_URL,
  get_headers,
  get_project_id,
  get_token
} from '@/utils/constants/constants.js';
import alert_mixin from '@/utils/mixins/alert_mixin';
import axios from "axios";

export default {
  name: 'TrustDirectory',
  components: { GlobalTable },
  mixins: [alert_mixin],

  data: () => ({
    token: '',
    project_id: '',
    headers: {},
    approved_applicants: [],
    sanitized_applicants: [],
    table_headers: [],
    _isMounted: false
  }),

  created() {
    this.token = get_token();
    this.project_id = get_project_id();
    this.headers = get_headers();

    if (!this.project_id) {
      this.show_error('Project ID is required');
      return;
    }
  },

  mounted() {
    this._isMounted = true;
    this.fetchTrustDirectoryEntries();
  },

  beforeUnmount() {
    this._isMounted = false;
  },

  methods: {
    async fetchTrustDirectoryEntries() {
      const params = { project_id: this.project_id };

      const response = await axios.get(TRUST_DIRECTORY_ENTRIES_URL, {
        headers: this.headers,
        params: params
      }).catch(error => {
        this.show_error('Error fetching trust directory entries: ' +
          (error.response?.data?.message || error.message));
        throw error;
      });

      if (!this._isMounted) return;

      if (response.data.status === 'success') {
        this.approved_applicants = response.data.data || [];
        this.prepareTableData();
      } else {
        this.show_error(response.data.message || 'Failed to fetch trust directory entries');
      }
    },

    prepareTableData() {
      this.sanitized_applicants = [];
      if (this.approved_applicants?.length > 0) {
        this.sanitized_applicants = this.approved_applicants.map(applicant => ({
          "ID": applicant.id,
          "Application No": `APP-${new Date(applicant.date_created).getFullYear()}-${applicant.id.toString().padStart(5, '0')}`,
          "Founder Name": applicant.founder_name || 'N/A',
          "Trust Name": applicant.trust_name || 'N/A',
          "Trust Number": applicant.trust_number || 'N/A',
          "Date Created": this.format_date(applicant.date_created) || 'N/A',
          "Status": applicant.status || 'N/A'
        }));
        this.table_headers = Object.keys(this.sanitized_applicants[0] || {});
      }
    },

    redirect_to_view_approved_applicant(applicant_id) {
      const applicant = this.approved_applicants.find(app => app.id === applicant_id);
      if (applicant) {
        sessionStorage.setItem('application_id', applicant.id);
        this.$router.push({
          path: '/overview_of_profile',
          query: {
            application_id: applicant.id,
            profile_role_id: applicant.profile_role_id
          }
        });
      }
    },

    format_date(dateString) {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
};